module.exports = __webpack_public_path__ + "img/20230226014549626tgj.c5b6ab30.png";